import { z } from 'zod'

export enum InputType {
  Hybrid = 'hybrid',
  Liquid = 'liquid',
  Granular = 'granular'
}
export const inputTypeSchema = z.enum(InputType)
